import { SetStateAction, useState } from 'react';
import Image from 'next/image';

interface IProps {
  city: string | undefined;
  setCity: React.Dispatch<SetStateAction<string | undefined>>;
  cityFilter: Record<string, any>;
  setCityFilter: React.Dispatch<React.SetStateAction<
    Record<string, any>
  > | null>;
  citiesDropdown: Record<string, any>[] | undefined;
  citiesToggle: boolean;
  setCitiesToggle: React.Dispatch<SetStateAction<boolean>>;
  currentPage: number;
  setCurrentPage: React.Dispatch<SetStateAction<number>>;
}
const sortCities = (cities: any) => {
  const sortedCities = cities
    ?.slice()
    .sort((a: any, b: any) => a.city.name.localeCompare(b.city.name));
  return sortedCities;
};

const CitiesSorting = ({
  cityFilter,
  setCityFilter,
  citiesDropdown,
  city,
  setCity,
  citiesToggle,
  setCitiesToggle,
  currentPage,
  setCurrentPage
}: IProps) => {
  const sortedCitiesDropdown = sortCities(citiesDropdown);
  return (
    <div id="reviews-cities-dropdown" className="relative">
      <div>
        <button
          className="pl-1 px-4 flex mx-auto md:mx-none justify-between items-center sm:pl-2 text-sm sm:text-[18px] bg-white border-2 rounded-lg h-[42px] w-[167px] xsm:w-[195px] md:w-[240px]"
          onClick={() => setCitiesToggle(!citiesToggle)}
        >
          <span className="pl-3">{city ? city : 'All Cities'}</span>
          <span className="inline-block pl-2">
            <Image
              src={
                'https://res.cloudinary.com/see-sight-tours/image/upload/v1686742410/Remaining%20images/Reviews/review-filtercitydropdown_mtjjfv.svg'
              }
              width={15}
              height={15}
              alt="dropdown"
            />
          </span>
        </button>
      </div>
      {citiesToggle && (
        <div className="bg-[#FFFFFF] rounded-b-[5px] max-h-[300px] overflow-y-auto absolute top-[100%] w-[100%] z-[60] border-2 rounded  ">
          <div
            onClick={() => {
              setCityFilter(null);
              setCity('All Cities');
              setCurrentPage(0);
            }}
            className={`border-b px-3 hover:cursor-pointer py-[2px] ${
              !city || city === 'All Cities' ? 'font-bold' : 'font-normal'
            }`}
          >
            All Cities
          </div>

          {sortedCitiesDropdown.map((cityItem: any) => (
            <div
              key={cityItem?.city.id}
              className={`border-b px-3 py-[2px] hover:cursor-pointer ${
                city === cityItem?.city?.name ? 'font-bold' : 'font-normal'
              }`}
              onClick={() => {
                setCity(cityItem?.city?.name);
                setCurrentPage(0);
                setCityFilter({
                  cities: {
                    id: cityItem?.city?.id,
                    slug: cityItem?.city.slug
                  }
                });
                setCitiesToggle(!citiesToggle);
              }}
            >
              {cityItem?.city.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CitiesSorting;
